<template>
	<div class="header-banner" :style="headerStyle">
		<div class="header-banner__info">
			<address v-if="venueAddress" class="header-banner__info__address">
				<div>
					{{ venueAddress.addressLine1 }}
					{{ venueAddress.addressLine2 }}
				</div>
				<div>
					{{ venueAddress.city }},
					{{ venueAddress.region }}
					{{ venueAddress.postalCode }}
				</div>
			</address>

			<venue-open-state />

			<div class="header-banner__info__actions">
				<a
					v-if="venuePhone"
					:href="`tel:${venuePhone}`"
					class="header-banner__info__actions__item"
				>
					<div class="icon-holder pt-2"><phone-icon /></div>
					<span class="mr-5">Call</span>
				</a>
				<div
					class="header-banner__info__actions__item"
					@click="openFooter('#footerAddress')"
				>
					<div class="icon-holder"><pin-icon /></div>
					<span>Address</span>
				</div>
				<div
					class="header-banner__info__actions__item"
					@click="openFooter('#footerSchedule')"
				>
					<div class="icon-holder pl-5"><clock-icon /></div>
					<span class="ml-6">Hours</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import PhoneIcon from '@/assets/svg/ic_phone.svg'
import PinIcon from '@/assets/svg/ic_pin.svg'
import ClockIcon from '@/assets/svg/ic_clock_solid.svg'
import VenueOpenState from '@/components/VenueOpenState.vue'
import { EventBus } from '@/utils/eventBus'

export default {
	name: 'HeaderBanner',

	components: { PhoneIcon, PinIcon, ClockIcon, VenueOpenState },

	computed: {
		...mapGetters('productCatalog', ['notEmptyCategories']),
		...mapGetters('venue', ['venueAddress', 'venuePhone', 'coverImage']),
		headerStyle() {
			const currentCategoryName = this.$route.params.category

			if (currentCategoryName && this.notEmptyCategories.length) {
				const currentCategory = this.notEmptyCategories.find(
					c => c.name === currentCategoryName
				)
				if (
					currentCategory &&
					currentCategory.categoryImage &&
					currentCategory.categoryImage.full
				) {
					return {
						backgroundImage: `url(${currentCategory.categoryImage.full})`
					}
				}
			}

			return this.coverImage
				? { backgroundImage: `url(${this.coverImage})` }
				: null
		}
	},

	methods: {
		openFooter(id) {
			EventBus.$emit('open-footer', id)
		}
	}
}
</script>

<style lang="scss" scoped>
@import './src/assets/styles/variables';
.header-banner {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	overflow: hidden;
	padding: 16px 16px 28px;
	border-radius: 12px;
	text-align: left;
	font-size: 18px;
	background-color: $deep-blue;
	background-size: cover;
	background-position: 50% 50%;

	@media (max-width: 1024px) {
		padding: 24px 10px 28px;
	}
	@media (max-width: 767px) {
		padding: 5px;
		min-height: 334px;
		margin-left: -16px;
		margin-right: -16px;
		border-radius: 0;
	}
	&:before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background-color: rgba($сarbon-night, 0.55);
	}
	&__info {
		min-width: 350px;
		padding: 19px 16px 9px 16px;
		border: 1px solid rgba($white, 0.2);
		border-radius: 12px;
		background: rgba($light-violet, 0.2);
		backdrop-filter: blur(12px);

		@media (max-width: 1024px) {
			min-width: 385px;
		}

		@media (max-width: 767px) {
			margin-top: 60px;
		}

		@media (max-width: 480px) {
			display: none;
		}

		&__address {
			margin-bottom: 20px;
			padding-left: 10px;
			font-style: normal;
			font-weight: 600;
			line-height: 25px;
			letter-spacing: 0.19px;
		}

		&__actions {
			display: flex;
			justify-content: space-between;
			padding-top: 16px;
			font-size: 18px;
			font-weight: 600;

			&:not(:has(> :nth-child(3))) {
				// Apply layout for groups with fewer than 3 items
				justify-content: space-around;
			}

			&__item {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: flex-start;
				width: 80px;
				text-decoration: none;
				color: rgba($white, 0.5);
				cursor: pointer;
				font-weight: 600;

				@media (min-width: 1024px) {
					&:hover .icon-holder {
						color: $blue-faceless-void;
					}
				}
			}
			.icon-holder {
				width: 34px;
				height: 34px;
				margin-bottom: 8px;
				color: $white;
				transition: color 0.3s;
			}
		}
	}
}
</style>
